var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { attrs: { title: _vm.configuracion.titulo } },
    [
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _c("span", [_vm._v(" Viendo documentos que ingresaron ")]),
          _vm.periodoSeleccionado.valor != "personalizado"
            ? _c("span", [
                _vm._v(" " + _vm._s(_vm.periodoSeleccionado.nombre) + " ")
              ])
            : _vm._e(),
          _vm.periodoSeleccionado.valor == "personalizado"
            ? _c(
                "span",
                [
                  _vm._v(" entre el "),
                  _c("datetime", {
                    attrs: {
                      "input-class": "fecha",
                      phrases: { ok: "Seleccionar", cancel: "Cancelar" },
                      "value-zone": "local",
                      format: "yyyy-MM-dd",
                      "data-cy": "start-time"
                    },
                    model: {
                      value: _vm.periodoDesde,
                      callback: function($$v) {
                        _vm.periodoDesde = $$v
                      },
                      expression: "periodoDesde"
                    }
                  }),
                  _vm._v(" y el "),
                  _c("datetime", {
                    attrs: {
                      "input-class": "fecha",
                      phrases: { ok: "Seleccionar", cancel: "Cancelar" },
                      "value-zone": "local",
                      format: "yyyy-MM-dd",
                      "data-cy": "end-time"
                    },
                    model: {
                      value: _vm.periodoHasta,
                      callback: function($$v) {
                        _vm.periodoHasta = $$v
                      },
                      expression: "periodoHasta"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "vs-dropdown",
            { staticStyle: { "margin-left": "15px" } },
            [
              _c(
                "a",
                { staticClass: "a-icon", attrs: { href: "#" } },
                [
                  _vm._v(" Cambiar "),
                  _c("vs-icon", { attrs: { icon: "expand_more" } })
                ],
                1
              ),
              _c(
                "vs-dropdown-menu",
                _vm._l(_vm.periodos, function(periodo) {
                  return _c(
                    "vs-dropdown-item",
                    {
                      key: periodo.valor,
                      staticStyle: { width: "200px" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.seleccionarPeriodo(periodo)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(periodo.nombre) + " ")]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "b-button",
            {
              staticClass: "badge-glow mb-3 ml-3",
              attrs: { variant: "warning", size: "sm" },
              on: {
                click: function($event) {
                  return _vm.downloadCSVFiles()
                }
              }
            },
            [
              _c("feather-icon", {
                staticClass: "mr-3",
                attrs: { icon: "DownloadIcon" }
              }),
              _c("span", { staticClass: "align-middle" }, [_vm._v("Descargar")])
            ],
            1
          )
        ],
        1
      ),
      _c("filtros", {
        attrs: {
          "configuracion-vista": _vm.configuracion,
          periodos: _vm.periodos
        },
        on: { "filtros-aplicados": _vm.manipularFiltros }
      }),
      _c("table", { attrs: { id: "listado-documentos" } }, [
        _c("thead", [
          _c(
            "tr",
            [
              _vm.product !== "aduanas"
                ? _c("th", { staticClass: "selector" }, [_c("vs-checkbox")], 1)
                : _vm._e(),
              _vm._l(_vm.campos, function(campo, index) {
                return _c(
                  "th",
                  {
                    key: index,
                    staticClass: "p-4",
                    attrs: { width: campo.ancho }
                  },
                  [_vm._v(" " + _vm._s(campo.nombre) + " ")]
                )
              }),
              _c("th")
            ],
            2
          )
        ]),
        !_vm.cargandoDocumentos && !_vm.documentos.length
          ? _c("tbody", [
              _c("tr", [
                _c(
                  "td",
                  {
                    staticClass: "mensaje-tabla",
                    attrs: { colspan: _vm.campos.length + 2 }
                  },
                  [_vm._v(" No se encontraron documentos ")]
                )
              ])
            ])
          : _c(
              "tbody",
              [
                _vm._l(_vm.documentos, function(doc) {
                  return [
                    _c(
                      "tr",
                      {
                        key: doc.febosId,
                        staticClass: "fila",
                        on: {
                          dblclick: function($event) {
                            return _vm.mostrarInfoExtendida(doc)
                          }
                        }
                      },
                      [
                        _vm.product !== "aduanas"
                          ? _c(
                              "td",
                              { staticClass: "selector" },
                              [_c("vs-checkbox")],
                              1
                            )
                          : _vm._e(),
                        _vm._l(_vm.campos, function(campo, index) {
                          return _c(
                            "td",
                            { key: index },
                            [
                              _c(_vm.cargarComponenteCampo(campo.campo), {
                                tag: "component",
                                attrs: { documento: doc }
                              })
                            ],
                            1
                          )
                        }),
                        _c(
                          "td",
                          { attrs: { width: "50" } },
                          [
                            _c("AccionesWrapper", {
                              attrs: {
                                "handle-list": _vm.handleEndAction,
                                acciones:
                                  _vm.configuracion.acccionesIndividuales,
                                documento: doc
                              }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ]
                })
              ],
              2
            )
      ]),
      _c(
        "vs-row",
        [
          _vm.documentos
            ? _c(
                "vs-col",
                {
                  attrs: {
                    "vs-offset": "2",
                    "vs-type": "flex",
                    "vs-justify": "center",
                    "vs-align": "center",
                    "vs-w": "8"
                  }
                },
                [
                  _c("info-tabla-basica", {
                    attrs: {
                      "items-de-esta-pagina": _vm.documentos.length,
                      "items-por-pagina": _vm.registrosPorPagina,
                      pagina: _vm.pagina,
                      "registros-totales": _vm.registrosEncontrados
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "vs-row",
        [
          _c(
            "vs-col",
            { attrs: { "vs-w": "3" } },
            [
              _c("selector-cantidad-registros", {
                staticClass: "mt-7",
                model: {
                  value: _vm.registrosPorPagina,
                  callback: function($$v) {
                    _vm.registrosPorPagina = $$v
                  },
                  expression: "registrosPorPagina"
                }
              })
            ],
            1
          ),
          _c(
            "vs-col",
            { attrs: { "vs-w": "9" } },
            [
              _c("fb-paginacion", {
                staticClass: "mt-7",
                attrs: { total: _vm.paginasTotales, max: 10 },
                model: {
                  value: _vm.pagina,
                  callback: function($$v) {
                    _vm.pagina = $$v
                  },
                  expression: "pagina"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("b-modal", {
        attrs: {
          title: "Información extendida",
          "no-close-on-backdrop": "",
          centered: "",
          "hide-footer": "",
          "content-class": "fullscreen",
          size: "xl"
        },
        nativeOn: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            _vm.informacionExtendida = false
          }
        },
        model: {
          value: _vm.informacionExtendida,
          callback: function($$v) {
            _vm.informacionExtendida = $$v
          },
          expression: "informacionExtendida"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }